export default "__VITE_ASSET__CwAozIMQ__"